export default "__VITE_ASSET__BGLtgu3i__"